export default "__VITE_PUBLIC_ASSET__3d86d2eb__"